export default __webpack_public_path__ + "static/media/icon-20-icn-no-gps.0f38fd0e.svg";